import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { analyticsConfigured, getConsent, setConsent, loadGa } from "@/lib/analytics";

// N'apparaît que si une mesure d'audience (REACT_APP_GA4_ID) est configurée.
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!analyticsConfigured) return;
    const c = getConsent();
    if (c === "granted") loadGa();
    else if (!c) setVisible(true);
  }, []);

  if (!visible) return null;
  const choose = (v) => { setConsent(v); setVisible(false); };

  return (
    <div role="dialog" aria-label="Gestion des cookies" data-testid="cookie-consent" className="fixed bottom-20 left-3 right-3 z-[65] max-w-md border border-ink/15 bg-ivory p-6 shadow-xl md:bottom-6 md:left-6">
      <p className="text-sm leading-relaxed text-ink">
        Nous utilisons une mesure d'audience pour comprendre l'usage du site, uniquement avec votre accord.{" "}
        <Link to="/politique-de-confidentialite" className="underline">En savoir plus</Link>
      </p>
      <div className="mt-4 flex gap-2">
        <button type="button" onClick={() => choose("denied")} data-testid="cookie-refuse" className="flex-1 rounded-full border border-ink/30 py-3 text-sm font-semibold">Refuser</button>
        <button type="button" onClick={() => choose("granted")} data-testid="cookie-accept" className="flex-1 rounded-full bg-ink py-3 text-sm font-semibold text-ivory">Accepter</button>
      </div>
    </div>
  );
}
